import { render, staticRenderFns } from "./SimpleNode.vue?vue&type=template&id=8cfa954c&scoped=true&"
import script from "./SimpleNode.vue?vue&type=script&lang=js&"
export * from "./SimpleNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfa954c",
  null
  
)

export default component.exports